"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

var Button = _styledComponents.default.button(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  background: var(--grey-light, #F0F0F0);\n  color: var(--black-main, #262626);\n  font-family: Roboto;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  padding: 10px 20px;\n  border: 0;\n  cursor: pointer;\n  &:first-child {\n    border-radius: 17px 0 0 17px;\n  }\n  &:last-child {\n    border-radius: 0 17px 17px 0;\n  }\n  ", "\n"])), function (_ref) {
  var isActive = _ref.isActive;
  return isActive && "\n    color: #FFFFFF;\n    background: var(--purple-medium, #8A6CAA);\n  ";
});

exports.Button = Button;